<template>
<div class="app-footer yo-bg-color-primary white">
   <div class="row pad-in">
      <div class="col s6 m8 yo-text-s" style="padding-left:14px;padding-top:10px;">

          

         <div class="row pad " style="height:45px;">
            <div class="col s12 m3 yo-align-left yo-valign-text-center yo-color-secondary yo-text-3xl yo-text-bold" style="height:45px;"><router-link to="/loadpage/contatti/contatti">CONTATTI</router-link></div>
            <!-- <div class="col s9 yo-valign-text-center yo-color-secondary yo-text-xxl yo-text-bold" style="height:70px;"><a class="white yo-text-l" href="mailto:innsin@biomedia.net" style="">innsin@biomedia.net</a></div> -->
         </div>

      </div>
      <div class="col s6 m4 yo-align-right yo-text-s" style="padding-top:10px;padding-right:14px;">
         <!-- <img src="../assets/bm.png" style="height:40px;"/> -->
      </div>
   </div>
</div>
</template>

<script>

export default {
  name: 'site-footer',
  components: {
  }
}
</script>
